/**
 * Type safe version to remove nulls and undefineds from array
 *
 * usage: `myArray.filter(notEmpty)`
 *
 * @param value
 * @returns
 */
export function notEmpty(value) {
    return value !== null && value !== undefined;
}
